import React, { useEffect, useState } from 'react'
import { CustomCheckbox, CustomDataTableHeader, CustomModal } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { connect } from 'react-redux'
import {
  assocCompaniesGroupToUser,
  getCompaniesGroupAssociatedToUser,
  getCompaniesGroupsWithItems,
} from '../../../../../services/api/https/system/system.http'

function ModalUsuarioCompaniesGroup({ userId, show, onClose, dispatch }) {
  const [companiesGroup, setCompaniesGroup] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getCompaniesGroupAssociatedToUser(userId)
      .then(companiesGroupsFromThisUser => {
        getCompaniesGroupsWithItems()
          .then(companiesGroup => {
            const companiesGroupsFromThisUserIds = companiesGroupsFromThisUser.map(
              cg => cg.company_group_id,
            )
            const companiesGroupsWithSelected = companiesGroup.map(cg => {
              return {
                ...cg,
                selected: companiesGroupsFromThisUserIds.includes(cg.id),
              }
            })
            setCompaniesGroup(companiesGroupsWithSelected)
            setIsLoading(false)
          })
          .catch(error => {
            dispatch(showMessageBox(null, error))
            setIsLoading(false)
          })
      })
      .catch(error => {
        dispatch(showMessageBox(null, error))
        setIsLoading(false)
      })
  }, [userId])

  // Events
  const onCheckboxChange = async companyGroup => {
    setIsLoading(true)
    assocCompaniesGroupToUser(userId, [companyGroup.id])
      .then(companiesGroupsFromThisUser => {
        const companiesGroupsFromThisUserIds = companiesGroupsFromThisUser.map(
          cg => cg.company_group_id,
        )
        const companiesGroupsWithSelected = companiesGroup.map(cg => ({
          ...cg,
          selected: companiesGroupsFromThisUserIds.includes(cg.id),
        }))
        setCompaniesGroup(companiesGroupsWithSelected)
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(showMessageBox(null, error))
        setIsLoading(false)
      })
  }

  // Render
  return (
    <CustomModal
      onClose={() => onClose('showModalCompaniesGroup')}
      header={'Associação - Grupo de Empresas'}
      width={600}
      isVisible={show}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <DataTable
            loading={isLoading}
            value={companiesGroup}
            paginator={true}
            rows={5}
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            globalFilter={globalFilter}
          >
            <Column
              header={'#'}
              body={companyGroup => (
                <CustomCheckbox
                  checked={companyGroup.selected}
                  onChange={() => onCheckboxChange(companyGroup)}
                />
              )}
              style={tableCellCentered(80)}
            />
            <Column field={'name'} header={'Grupo de Empresas'} />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(ModalUsuarioCompaniesGroup)
